module.exports = __webpack_public_path__ + "img/读卡器一体机斜面.b650f1ba.png";